/*
 * Main Frontend
 */
(function () {
    'use_strict';

    //Starting APP
    var filter = angular.module('shoveler-filter', []);
    
    filter.config(['$compileProvider', function ($compileProvider) {
      $compileProvider.debugInfoEnabled(false);
    }]);
})();